<template>
  <v-layout column fluid>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">settings</v-icon>
        Bulletin Board
        <template slot="buttons">
          <router-link :to="{ name: 'settingsIndex' }">Back to All Settings</router-link>
        </template>
      </HeaderBar>
    </v-flex>

    <v-flex>
      <h2 class="display-1 mb-4">Bulletins:</h2>
    </v-flex>
    <v-flex v-if="gettingBulletins || deletingBulletin">
      <v-progress-circular indeterminate>
      </v-progress-circular>
    </v-flex>
    <v-flex v-else class="mb-4">
      <div v-if="!bulletins || bulletins.length < 1">
        No bulletins yet...
      </div>
      <div v-else>
        <ul>
          <li
            v-for="bulletin in bulletins"
            :key="bulletin.id"
            class="bulletin"
          >
            "{{ bulletin.message }}" - for users: {{ bulletin.role || "any" }}
            <span v-if="user.bohOrHigher && !deletingBulletin" class="bulletin-remove">
              <a href="#" @click.prevent="deleteBulletin(bulletin.id)" color="error" class="red--text">
                <v-icon color="red">
                  cancel
                </v-icon>
              </a>
            </span>
          </li>
        </ul>
      </div>
    </v-flex>
    <v-flex v-if="user.bohOrHigher">
      <v-layout row>
        <v-flex shrink class="mr-2">
          <v-textarea
            label="Message"
            box
            v-model="newBulletinMessage"
          ></v-textarea>
          <v-select
            label="For Users..."
            :items="roles"
            v-model="newBulletinRole"
          ></v-select>
        </v-flex>
        <v-btn @click="createBulletin" color="success" :disabled="creatingBulletin" :loading="creatingBulletin">
          <v-icon left>
            add
          </v-icon>
          Add Bulletin
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      bulletins: [],
      gettingBulletins: false,
      deletingBulletin: false,
      deletingBulletinId: null,
      creatingBulletin: false,
      newBulletinMessage: '',
      newBulletinRole: '',
      roles: [
        "any",
        "employee",
        "client",
        "manager",
        "boh",
        "superadmin",
      ]
    }
  },
  methods: {
    setUp () {
      this.getAllBulletins()
    },
    createBulletin () {
      this.creatingBulletin = true
      this.$store.dispatch('bulletinBoard/create', {
        message: this.newBulletinMessage,
        role: this.newBulletinRole,
      })
      .then(r => {
        this.bulletins.push(r)
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Bulletin created!" })
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('global/showSnackbarError', { message: 'There was something wrong with that bulletin.' })
      })
      .finally(r => {
        this.creatingBulletin = false
        this.newBulletinRole = ''
        this.newBulletinMessage = ''
      })
    },
    getAllBulletins () {
      this.gettingBulletins = true
      this.$store.dispatch('bulletinBoard/getAll')
      .then(r => {
        this.bulletins = r
      })
      .catch(error => {
        console.log(error)
      })
      .finally(r => {
        this.gettingBulletins = false
      })
    },
    deleteBulletin (id) {
      this.deletingBulletin = true
      this.deletingBulletinId = id
      this.$store.dispatch('bulletinBoard/delete', id)
      .then(r => {
        this.bulletins = [
          ...this.bulletins.filter(h => h.id !== id)
        ]
        this.$store.dispatch('global/showSnackbarSuccess', { message: "Bulletin deleted!" })
      })
      .catch(error => {
        this.$store.dispatch('global/showSnackbarError', { message: "Couldn't delete that bulletin" })
      })
      .finally(r => {
        this.deletingBulletin = false
        this.deletingBulletinId = null
      })
    },
  },
}
</script>

<style scoped>
.bulletin-remove {
  visibility: hidden;
  animation: none;
}

.bulletin:hover .bulletin-remove {
  visibility: visible;
  display: inline-block;
}
</style>
